<template>
    <div class="home-container">
        <!-- 轮播 Banner -->
        <!-- <el-carousel
            class="banner-carousel"
            :interval="5000"
            :arrow="showControls ? 'always' : 'never'"
            :indicator-position="showIndicators ? 'outside' : 'none'"
        >
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item.image" class="banner-image" alt="FOGO" />
            </el-carousel-item>
        </el-carousel> -->
        <div class="banner-carousel">
            <img :src="bannerList[0].image" class="banner-image" alt="FOGO" />
        </div>

        <!-- 套餐列表 -->
        <div class="package-container">
            <el-row :gutter="gutterSize">
                <el-col
                    v-for="item in planList"
                    :key="item.goodsId"
                    :xs="12"
                    :sm="12"
                    :md="8"
                    :lg="6"
                    class="package-col"
                >
                    <div v-if="item.discountRatio" class="discount-badge">
                        {{ $t('about') }}&nbsp;{{ item.discountRatio }}% OFF
                    </div>
                    <el-card shadow="hover" class="plan-card">
                        <div slot="header" class="plan-header">
                            <span>{{ item.goodsName }}</span>
                        </div>
                        <div class="plan-price">
                            <span class="price-title"
                                >{{ $t('price') }}:</span
                            >
                            <span class="original-price">
                                {{ item.goodsAmountCcy }}&nbsp;{{
                                    Number(
                                        item.goodsOriginalAmount
                                    ).toFixed(2)
                                }}
                            </span>
                            <span class="price">
                                {{ item.goodsAmountCcy }}&nbsp;{{
                                    Number(item.goodsAmount).toFixed(2)
                                }}
                            </span>
                        </div>
                        <div class="plan-price">
                            <span
                                class="avg-price"
                                v-if="item.goodsAverageAmount"
                                >{{ $t('Average') }}&nbsp;{{
                                    item.goodsAmountCcy
                                }}&nbsp;{{
                                    Number(item.goodsAverageAmount).toFixed(
                                        2
                                    )
                                }}{{ $t('monthly') }}</span
                            >
                        </div>
                        <el-button
                            @click="handleSelect(item)"
                            :loading="upgradeLoading"
                            style="
                                background-color: #ee3769;
                                color: #ffffff;
                            "
                            >{{ $t('buyNow') }}</el-button
                        >
                        <div
                            class="plan-details"
                            v-html="item.goodsDescription"
                        ></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 支付弹窗 -->
        <qr-code-payment-dialog
            :visible.sync="paymentDialogVisible"
            :plan-name="selectedPlanName"
            :plan-amount="selectedPlanAmount"
            :plan-currency="selectedPlanCurrency"
            :qr-code-image="qrCodeImage"
            :order-sn="orderSn"
            @completed="handlePaymentCompleted"
        />
    </div>
</template>

<script>
import { getPlanList, getOrderToken, createOrder } from '@/api/order'
import { createErrorHandler } from '@/utils/errorHandler'
import { ssoLogin } from '@/api/user'
import QrCodePaymentDialog from '@/components/QrCodePaymentDialog.vue'

export default {
    components: {
        QrCodePaymentDialog
    },
    data() {
        return {
            planList: [],
            token: '',
            selectPlanObj: '',
            upgradeLoading: false,
            gutterSize: 40,
            paymentDialogVisible: false,
            qrCodeImage: '',
            orderSn: '',
            selectedPlanName: '',
            selectedPlanAmount: '',
            selectedPlanCurrency: ''
        }
    },
    async mounted() {
        this.errorHandler = createErrorHandler(this)
        this.updateGutterSize()
        window.addEventListener('resize', this.updateGutterSize)
        await this.handleUrlParams()
        this.getAllPlanList()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateGutterSize)
    },
    computed: {
        bannerList() {
            const isPortuguese = this.$i18n.locale.startsWith('pt')
            return [
                {
                    image: require('@/assets/img/' +
                        (isPortuguese
                            ? 'banner-pt-new.png'
                            : 'banner-en-new.png'))
                }
            ]
        },
        showControls() {
            return this.bannerList.length > 1
        },
        showIndicators() {
            return this.bannerList.length > 1
        }
    },
    methods: {
        updateGutterSize() {
            this.gutterSize = window.innerWidth <= 768 ? 12 : 40
        },
        handleUrlParams() {
            const { authCode, lang, tab } = this.$route.query
            if (lang) {
                this.$i18n.locale = lang
                localStorage.setItem('locale', lang)
            }
            if (tab) {
                // tab 参数预留，后续可按需使用
            }
            if (authCode) {
                return ssoLogin({ ticket: authCode })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$store.dispatch('login', res.data)
                            this.$router.replace({ query: {} })
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        }
                    })
                    .catch((err) => console.log(err))
            }
            return Promise.resolve()
        },
        handleSelect(item) {
            this.selectPlanObj = item
            this.upgradeLoading = true
            this.selectedPlanName = item.goodsName
            this.selectedPlanAmount = Number(item.goodsAmount).toFixed(2)
            this.selectedPlanCurrency = item.goodsAmountCcy
            this.getCreateOrderToken()
        },
        // 获取生成订单token
        getCreateOrderToken() {
            getOrderToken({
                goodsId: this.selectPlanObj.goodsId
            })
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.token = res.data
                        this.createOrder()
                    } else {
                        this.upgradeLoading = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.upgradeLoading = false
                })
        },
        // 创建订单
        createOrder() {
            createOrder({
                goodsId: this.selectPlanObj.goodsId,
                orderToken: this.token
            })
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        if (res.data.paymentQrCode) {
                            // 有二维码，显示弹窗（base64图片）
                            const qrCode = res.data.paymentQrCode
                            this.qrCodeImage = qrCode.startsWith('data:image')
                                ? qrCode
                                : `data:image/png;base64,${qrCode}`
                            this.orderSn = res.data.orderSn || ''
                            this.paymentDialogVisible = true
                        } else {
                            // 无二维码，跳转支付链接
                            window.location.href = res.data.paymentLink
                        }
                    }
                    this.upgradeLoading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.upgradeLoading = false
                })
        },
        // 处理支付完成
        handlePaymentCompleted() {
            this.paymentDialogVisible = false
            this.qrCodeImage = ''
            this.orderSn = ''
            this.selectedPlanName = ''
            this.selectedPlanAmount = ''
            this.selectedPlanCurrency = ''
        },
        getAllPlanList() {
            getPlanList()
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.planList = res.data
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped>
.home-container {
    /* max-width: 1200px; */
    margin: 0 auto;
}

/* Banner 样式 */
.banner-carousel {
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    /* height: 100%; */
    /* object-fit: cover; */
}

.banner-title {
    position: absolute;
    left: 50px;
    bottom: 60px;
    color: #fff;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

.banner-title h2 {
    font-size: 32px;
    margin-bottom: 10px;
}

.banner-title p {
    font-size: 18px;
}

/* 自定义指示器样式 */
::v-deep .el-carousel__indicator button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
}

::v-deep .el-carousel__indicator.is-active button {
    background-color: #409eff;
}

::v-deep .el-carousel__arrow {
    background-color: rgba(255, 255, 255, 0.8);
    color: #333;
}

::v-deep .el-carousel__arrow:hover {
    background-color: rgba(255, 255, 255, 0.9);
}
.package-container {
    padding: 0 50px;
}

/* 套餐卡片样式 */
.package-card {
    margin-bottom: 20px;
    transition: transform 0.3s;
    position: relative;
}

.package-card:hover {
    transform: translateY(-5px);
}

.package-info {
    padding: 15px;
}

.package-title {
    font-size: 18px;
    margin-bottom: 10px;
    color: #333;
}

.package-desc {
    font-size: 14px;
    color: #666;
    height: 40px;
    overflow: hidden;
    margin-bottom: 15px;
}

.price-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.package-col {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
}
.package-col:hover {
    transform: translateY(-5px);
}
.plan-card {
    margin-bottom: 20px;
    text-align: center;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}
/* 卡片内容区撑满，按钮和描述推到底部 */
.plan-card ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.plan-card ::v-deep .el-card__body .el-button {
    margin-top: auto;
}
/* .plan-card:hover {
    transform: translateY(-5px);
} */

.plan-header {
    font-size: 18px;
    color: #ff4d4f;
    font-weight: bold;
}

.plan-price {
    /* font-size: 24px; */
    margin: 10px 0;
    min-height: 21px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.price-title {
    font-size: 20px;
    font-weight: bold;
}
.price {
    font-weight: bold;
    display: block;
}

.original-price {
    font-size: 14px;
    color: #ff6b6b;
    font-weight: bold;
    text-decoration: line-through;
    margin: 4px auto;
    display: block;
}

.unit {
    font-size: 14px;
}

.avg-price {
    font-size: 14px;
    color: #999;
}

.plan-details {
    list-style-type: none;
    padding: 0;
    margin-top: 12px;
    text-align: left;
    flex-shrink: 0;
}

.plan-details li {
    margin: 5px 0;
    font-size: 14px;
}

.plan-footer {
    text-align: center;
    margin-top: 20px;
}
.discount-badge {
    position: absolute;
    top: -12px;
    right: -10px;
    background-color: #ff3f15;
    color: white;
    border-radius: 50%;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .package-container {
        padding: 0 10px;
    }

    .banner-carousel {
        margin-bottom: 12px;
    }

    .banner-image {
        max-height: 160px;
    }

    .banner-title {
        left: 20px;
        bottom: 30px;
    }

    .banner-title h2 {
        font-size: 18px;
    }

    .banner-title p {
        font-size: 14px;
    }

    /* 卡片样式 - 移动端紧凑化 */
    .plan-card {
        margin-bottom: 10px;
    }

    .plan-card ::v-deep .el-card__header {
        padding: 8px 10px;
    }

    .plan-card ::v-deep .el-card__body {
        padding: 8px 10px;
    }

    .plan-header {
        font-size: 14px;
    }

    .plan-price {
        margin: 4px 0;
        min-height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .price-title {
        font-size: 13px;
    }

    .price {
        font-size: 14px;
    }

    .original-price {
        font-size: 11px;
    }

    .avg-price {
        font-size: 11px;
    }

    /* 购买按钮 - 移动端缩小 */
    .plan-card .el-button {
        padding: 6px 12px;
        font-size: 12px;
    }

    /* 套餐描述 - 移动端限制高度保证卡片等高 */
    .plan-details {
        margin-top: 8px;
        font-size: 11px;
        max-height: 80px;
        overflow: hidden;
    }

    .plan-details ::v-deep li {
        font-size: 11px;
        margin: 2px 0;
    }

    .package-title {
        font-size: 16px;
    }

    .package-desc {
        font-size: 13px;
        height: 36px;
    }

    .discount-badge {
        top: -6px;
        right: 6px;
        padding: 3px 6px;
        font-size: 10px;
    }
}
</style>